import { Component, OnInit } from '@angular/core';

declare const $: any;

@Component({
    selector: 'yes-no-dialog',
    templateUrl: './yes-no.html'
})
export class YesNoComponent implements OnInit {
    _title: string;
    _message: string;
    _buttonNames: string[];
    _result: boolean;

    ngOnInit() {
    }

    select(isYes: boolean) {
        this._result = isYes;
        this.getModalEle().modal('hide');
    }

    showModal(title: string, message: string, buttonNames?: string []): Promise<boolean> {
        this._title = title;
        this._message = message;
        this._buttonNames = buttonNames || ['Yes', 'No' ];
        const ele = this.getModalEle();
        const p = new Promise( (resolve, reject) => {
            ele.modal({ backdrop: 'static', keyboard: false }).on('hidden.bs.modal', () => {
                resolve(this._result);
            });
        });
        return <any>p;
    }

    getModalEle(): any {
        return $('#yes-no-modal');
    }
}

